import React, { createContext, useContext, useState, useCallback } from "react";

export const WHATSAPP_NUMBER = "31659128521";
export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

const translations = {
  nl: {
    nav: {
      services: "Diensten",
      pricing: "Prijzen",
      about: "Over ons",
      becomeCleaner: "Schoonmaker worden",
      contact: "Contact",
      cta: "Schoonmaker aanvragen",
    },
    hero: {
      badge: "Bemiddeling in schoonmaak",
      title: "Een betrouwbare schoonmaker voor uw woning of bedrijf",
      subtitle:
        "Onze eigen, zorgvuldig gescreende schoonmakers zorgen voor een schoon resultaat. Vraag vandaag nog vrijblijvend een offerte aan.",
      cta1: "Plan uw schoonmaak",
      cta2: "Bekijk hoe het werkt",
      stat1: "Zorgvuldig gescreende schoonmakers",
      stat2: "Vaste schoonmaker waar mogelijk",
      stat3: "Snel en eenvoudig geregeld",
      usps: [
        "Eigen, gescreende schoonmakers",
        "Schoonmaakmiddelen inbegrepen",
        "Binnen enkele minuten aangevraagd",
      ],
    },
    trust: {
      title: "Waarom klanten ons vertrouwen",
      items: [
        { t: "Gescreende schoonmakers", d: "Elke schoonmaker wordt persoonlijk gecheckt." },
        { t: "Binnen 24–48 uur geregeld", d: "Snelle matching bij jou in de buurt." },
        { t: "Particulier & zakelijk", d: "Voor thuis én op kantoor." },
        { t: "Flexibel per uur", d: "Geen lange contracten, jij bepaalt." },
      ],
    },
    services: {
      title: "Onze schoonmaakdiensten",
      subtitle: "Van wekelijkse schoonmaak tot dieptereiniging — wij regelen het.",
      items: [
        { t: "Particuliere schoonmaak", d: "Wekelijks of eenmalig. Huizen en appartementen." },
        { t: "Kantoorschoonmaak", d: "Vaste of flexibele planning. Kantoren en werkruimtes." },
        { t: "Dieptereiniging", d: "Keuken en badkamer intensief. Verhuizing of oplevering." },
        { t: "Airbnb schoonmaak", d: "Snelle wissels tussen gasten. Klaar voor nieuwe check-ins." },
      ],
    },
    how: {
      title: "Zo werkt MyCleaner",
      steps: [
        { t: "Vraag een schoonmaker aan", d: "Vul het formulier in of stuur ons een WhatsApp." },
        { t: "Wij matchen de juiste schoonmaker", d: "Op basis van jouw wensen en regio." },
        { t: "Schoonmaker komt op afspraak", d: "Op een moment dat jou uitkomt." },
        { t: "Jij geniet van een schoon resultaat", d: "Zonder gedoe, keer op keer." },
      ],
    },
    pricing: {
      title: "Transparante tarieven",
      subtitle: "Heldere tarieven zonder verborgen kosten. De uiteindelijke prijs is afhankelijk van de werkzaamheden, de grootte van de locatie en de gewenste frequentie. Na uw aanvraag ontvangt u altijd een vrijblijvende prijsopgave.",
      from: "Vanaf",
      unit: "per uur",
      items: [
        { t: "Particuliere schoonmaak", p: "€25", d: "Voor een frisse en schone woning, eenmalig of op vaste basis. Onze schoonmakers werken zorgvuldig en nemen alle benodigde schoonmaakmiddelen mee." },
        { t: "Kantoorschoonmaak", p: "€22", d: "Flexibele schoonmaak voor kantoren en zakelijke ruimtes, volledig afgestemd op uw wensen en planning." },
        { t: "Dieptereiniging", p: "€30", d: "Een intensieve schoonmaak met extra aandacht voor hardnekkig vuil, sanitair, keukens en moeilijk bereikbare plekken." },
        { t: "Airbnb & Vakantieverhuur", p: "€25", d: "Snelle en professionele schoonmaak tussen verblijven, zodat uw accommodatie altijd schoon en representatief is voor de volgende gasten." },
      ],
      benefitsTitle: "Waarom kiezen voor MyCleaner?",
      benefits: [
        "Eigen, zorgvuldig gescreende schoonmakers",
        "Schoonmaakmiddelen inbegrepen (u stelt alleen een stofzuiger en dweil beschikbaar)",
        "Geen verborgen kosten",
        "Flexibel in te plannen",
        "Vrijblijvende prijsopgave vooraf",
      ],
      ctaTitle: "Vraag vrijblijvend een offerte aan",
      ctaText: "Binnen enkele minuten aangevraagd. U ontvangt altijd vooraf een duidelijke prijsopgave zonder verrassingen.",
    },
    why: {
      title: "Waarom MyCleaner",
      subtitle: "Geen anonieme bemiddeling, maar eigen schoonmakers waar u op kunt bouwen.",
      cards: [
        { t: "Eigen, gescreende schoonmakers", d: "Wij werken met onze eigen schoonmakers, zorgvuldig geselecteerd en gecontroleerd." },
        { t: "Vaste schoonmaker waar mogelijk", d: "Dezelfde vertrouwde schoonmaker die uw woning en wensen kent." },
        { t: "Flexibele planning", d: "Eenmalig, wekelijks of maandelijks — u bepaalt wanneer." },
        { t: "Transparante tarieven", d: "Duidelijke richtprijzen vooraf, zonder verrassingen achteraf." },
      ],
    },
    social: {
      title: "Vertrouwd door steeds meer huishoudens en bedrijven",
      subtitle: "Particulieren en bedrijven kiezen voor MyCleaner vanwege onze betrouwbare service, gescreende schoonmakers en persoonlijke aanpak.",
      stats: [
        { v: "50+", l: "Huishoudens geholpen" },
        { v: "1.200+", l: "Schoonmaakuren uitgevoerd" },
        { v: "4,9/5", l: "Gemiddelde beoordeling", note: "op basis van 38 beoordelingen" },
      ],
      testimonials: [
        { name: "Sanne de Vries", city: "Amsterdam", text: "Fijne vaste schoonmaker die precies weet hoe ik het wil. Binnen twee dagen geregeld!" },
        { name: "Mark Jansen", city: "Utrecht", text: "Betrouwbaar en flexibel. Ons kantoor is nog nooit zo schoon geweest." },
        { name: "Fatima El Amrani", city: "Rotterdam", text: "Simpel aangevraagd via het formulier en snel een match. Echt een aanrader." },
      ],
    },
    about: {
      title: "Over ons",
      text: "MyCleaner is opgericht met één doel: schoonmaak eenvoudig en betrouwbaar maken. Wij koppelen klanten aan betrouwbare schoonmakers zonder gedoe.",
    },
    become: {
      badge: "Voor schoonmakers",
      title: "Word schoonmaker bij MyCleaner",
      text: "Ben jij betrouwbaar en heb je ervaring in schoonmaak? Werk flexibel en krijg opdrachten bij jou in de buurt.",
      benefitsTitle: "Jouw voordelen",
      benefits: [
        "Flexibele werktijden",
        "Klussen in eigen regio",
        "Snelle uitbetaling",
        "Ondersteuning en planning",
        "Meer opdrachten bij goede prestaties",
      ],
      howTitle: "Hoe het werkt",
      how: ["Aanmelden", "Korte kennismaking", "Eerste opdrachten ontvangen", "Meer werk bij goede reviews"],
      cta1: "Aanmelden als schoonmaker",
      cta2: "WhatsApp sollicitatie",
    },
    finalCta: {
      title: "Klaar om een schoonmaker te regelen?",
      subtitle: "Vraag vandaag nog aan en ervaar het gemak van MyCleaner.",
      cta1: "Schoonmaker aanvragen",
      cta2: "WhatsApp ons direct",
    },
    contact: {
      title: "Neem contact op",
      subtitle: "Liever direct contact? App ons op WhatsApp.",
      cta: "WhatsApp ons",
    },
    footer: {
      tagline: "Betrouwbare schoonmaak, eenvoudig geregeld.",
      services: "Diensten",
      company: "Bedrijf",
      contact: "Contact",
      privacy: "Privacybeleid",
      rights: "Alle rechten voorbehouden.",
    },
    forms: {
      customerTitle: "Schoonmaker aanvragen",
      cleanerTitle: "Aanmelden als schoonmaker",
      name: "Naam",
      phone: "Telefoonnummer",
      email: "E-mail",
      city: "Woonplaats",
      service: "Type dienst",
      message: "Bericht",
      experience: "Ervaring",
      availability: "Beschikbaarheid",
      selectService: "Kies een dienst",
      submitCustomer: "Aanvraag versturen",
      submitCleaner: "Aanmelding versturen",
      submitContact: "Bericht versturen",
      sending: "Versturen...",
      successCustomer: "Bedankt! We nemen snel contact met je op.",
      successCleaner: "Bedankt voor je aanmelding! We nemen contact op.",
      successContact: "Bericht verzonden! We reageren zo snel mogelijk.",
      error: "Er ging iets mis. Probeer het opnieuw of app ons.",
      required: "Vul alle verplichte velden in.",
      optional: "optioneel",
    },
  },
  en: {
    nav: {
      services: "Services",
      pricing: "Pricing",
      about: "About",
      becomeCleaner: "Become a cleaner",
      contact: "Contact",
      cta: "Request a cleaner",
    },
    hero: {
      badge: "Cleaning matchmaking",
      title: "A reliable cleaner for your home or business",
      subtitle:
        "Our own, carefully screened cleaners deliver a spotless result. Request a no-obligation quote today.",
      cta1: "Plan your cleaning",
      cta2: "See how it works",
      stat1: "Carefully screened cleaners",
      stat2: "Regular cleaner where possible",
      stat3: "Fast and easy to arrange",
      usps: [
        "Our own screened cleaners",
        "Cleaning supplies included",
        "Requested in just minutes",
      ],
    },
    trust: {
      title: "Why clients trust us",
      items: [
        { t: "Screened cleaners", d: "Every cleaner is personally vetted." },
        { t: "Arranged within 24–48h", d: "Fast matching near you." },
        { t: "Private & business", d: "For home and office alike." },
        { t: "Flexible per hour", d: "No long contracts, you decide." },
      ],
    },
    services: {
      title: "Our cleaning services",
      subtitle: "From weekly cleaning to deep cleans — we arrange it all.",
      items: [
        { t: "Home cleaning", d: "Weekly or one-off. Houses and apartments." },
        { t: "Office cleaning", d: "Fixed or flexible schedule. Offices and workspaces." },
        { t: "Deep cleaning", d: "Intensive kitchen and bathroom. Move-out or handover." },
        { t: "Airbnb cleaning", d: "Fast turnarounds between guests. Ready for check-ins." },
      ],
    },
    how: {
      title: "How MyCleaner works",
      steps: [
        { t: "Request a cleaner", d: "Fill in the form or send us a WhatsApp." },
        { t: "We match the right cleaner", d: "Based on your needs and region." },
        { t: "Cleaner arrives on schedule", d: "At a time that suits you." },
        { t: "Enjoy a spotless result", d: "Hassle-free, time after time." },
      ],
    },
    pricing: {
      title: "Transparent rates",
      subtitle: "Clear rates without hidden costs. The final price depends on the work, the size of the location and the desired frequency. After your request you always receive a no-obligation quote.",
      from: "From",
      unit: "per hour",
      items: [
        { t: "Home cleaning", p: "€25", d: "For a fresh and clean home, one-off or on a regular basis. Our cleaners work carefully and bring all the required cleaning supplies." },
        { t: "Office cleaning", p: "€22", d: "Flexible cleaning for offices and business spaces, fully tailored to your wishes and schedule." },
        { t: "Deep cleaning", p: "€30", d: "An intensive clean with extra attention for stubborn dirt, sanitary areas, kitchens and hard-to-reach spots." },
        { t: "Airbnb & holiday rentals", p: "€25", d: "Fast, professional cleaning between stays, so your accommodation is always clean and presentable for the next guests." },
      ],
      benefitsTitle: "Why choose MyCleaner?",
      benefits: [
        "Our own, carefully screened cleaners",
        "Cleaning supplies included (you only provide a vacuum and mop)",
        "No hidden costs",
        "Flexible scheduling",
        "No-obligation quote upfront",
      ],
      ctaTitle: "Request a no-obligation quote",
      ctaText: "Requested in minutes. You always receive a clear quote upfront, no surprises.",
    },
    why: {
      title: "Why MyCleaner",
      subtitle: "Not anonymous matchmaking, but our own cleaners you can rely on.",
      cards: [
        { t: "Our own screened cleaners", d: "We work with our own cleaners, carefully selected and vetted." },
        { t: "Regular cleaner where possible", d: "The same trusted cleaner who knows your home and wishes." },
        { t: "Flexible scheduling", d: "One-off, weekly or monthly — you decide when." },
        { t: "Transparent pricing", d: "Clear indicative rates upfront, no surprises afterwards." },
      ],
    },
    social: {
      title: "Trusted by more and more households and businesses",
      subtitle: "Private clients and businesses choose MyCleaner for our reliable service, screened cleaners and personal approach.",
      stats: [
        { v: "50+", l: "Households helped" },
        { v: "1,200+", l: "Cleaning hours delivered" },
        { v: "4.9/5", l: "Average rating", note: "based on 38 reviews" },
      ],
      testimonials: [
        { name: "Sanne de Vries", city: "Amsterdam", text: "A lovely regular cleaner who knows exactly how I like it. Arranged within two days!" },
        { name: "Mark Jansen", city: "Utrecht", text: "Reliable and flexible. Our office has never been this clean." },
        { name: "Fatima El Amrani", city: "Rotterdam", text: "Easy to request via the form and matched quickly. Highly recommended." },
      ],
    },
    about: {
      title: "About us",
      text: "MyCleaner was founded with one goal: to make cleaning simple and reliable. We connect clients with trustworthy cleaners without the hassle.",
    },
    become: {
      badge: "For cleaners",
      title: "Become a cleaner at MyCleaner",
      text: "Are you reliable and experienced in cleaning? Work flexibly and get jobs near you.",
      benefitsTitle: "Your benefits",
      benefits: [
        "Flexible working hours",
        "Jobs in your own region",
        "Fast payment",
        "Support and planning",
        "More jobs for great performance",
      ],
      howTitle: "How it works",
      how: ["Sign up", "Short intro call", "Receive first jobs", "More work with good reviews"],
      cta1: "Sign up as a cleaner",
      cta2: "WhatsApp application",
    },
    finalCta: {
      title: "Ready to arrange a cleaner?",
      subtitle: "Request today and experience the ease of MyCleaner.",
      cta1: "Request a cleaner",
      cta2: "WhatsApp us now",
    },
    contact: {
      title: "Get in touch",
      subtitle: "Prefer direct contact? Message us on WhatsApp.",
      cta: "WhatsApp us",
    },
    footer: {
      tagline: "Reliable cleaning, simply arranged.",
      services: "Services",
      company: "Company",
      contact: "Contact",
      privacy: "Privacy policy",
      rights: "All rights reserved.",
    },
    forms: {
      customerTitle: "Request a cleaner",
      cleanerTitle: "Sign up as a cleaner",
      name: "Name",
      phone: "Phone number",
      email: "Email",
      city: "City",
      service: "Service type",
      message: "Message",
      experience: "Experience",
      availability: "Availability",
      selectService: "Choose a service",
      submitCustomer: "Send request",
      submitCleaner: "Send application",
      submitContact: "Send message",
      sending: "Sending...",
      successCustomer: "Thank you! We'll contact you shortly.",
      successCleaner: "Thanks for signing up! We'll be in touch.",
      successContact: "Message sent! We'll respond as soon as possible.",
      error: "Something went wrong. Please try again or message us.",
      required: "Please fill in all required fields.",
      optional: "optional",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("mc_lang") || "nl");
  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "nl" ? "en" : "nl";
      localStorage.setItem("mc_lang", next);
      return next;
    });
  }, []);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
